// app/components/privacy-graph-scrolly/elements/finding-chip.tsx

import { FINDING_CHIP } from "../graph-layout";

interface Props {
  x: number;
  y: number;
  label: string;
}

const PADDING_X = 10;
const BAR_W = 3;
const HEIGHT = 20;

export function FindingChip({ x, y, label }: Props) {
  const charW = 5.8;
  const w = label.length * charW + PADDING_X * 2 + BAR_W;
  return (
    <g transform={`translate(${x}, ${y})`}>
      <rect
        width={w}
        height={HEIGHT}
        rx={3}
        fill={FINDING_CHIP.fill}
        stroke={FINDING_CHIP.stroke}
        strokeWidth={1}
      />
      <rect
        x={0}
        y={0}
        width={BAR_W}
        height={HEIGHT}
        fill={FINDING_CHIP.bar}
      />
      <text
        x={BAR_W + PADDING_X}
        y={HEIGHT / 2 + 4}
        fontSize={11}
        fill={FINDING_CHIP.text}
        fontFamily="var(--font-sans, system-ui, sans-serif)"
        fontWeight={500}
      >
        {label}
      </text>
    </g>
  );
}

export function findingChipWidth(label: string): number {
  return label.length * 5.8 + PADDING_X * 2 + BAR_W;
}
